// src/data/translations.js

export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      prices: "Tarifs",
      gallery: "Galerie",
      about: "À Propos",
      contact: "Contact",
      book: "Réserver"
    },
    hero: {
      subtitle: "SALON DE COIFFURE PREMIUM",
      title: "L'Art de la",
      titleHighlight: "Coiffure Masculine",
      description: "Découvrez l'excellence du barbier moderne. Expertise, passion et style au service de votre image.",
      cta: "Prendre Rendez-vous",
      ctaSecondary: "Découvrir nos tarifs",
      badge: "Top Rated Treatwell 2025"
    },
    services: {
      title: "Nos Services",
      subtitle: "Excellence & Savoir-faire",
      description: "Des prestations haut de gamme pour sublimer votre style",
      men: "HOMMES",
      children: "ENFANTS",
      childrenNote: "Moins de 12 ans",
      eveningSurcharge: "+5€ à partir de 18h30",
      items: {
        coupe: "Coupe",
        coupeCiseaux: "Coupe Ciseaux",
        coupeBouZero: "Coupe Boule à Zéro",
        barbe: "Barbe",
        bouZeroBarbe: "Boule à Zéro & Barbe",
        contours: "Contours",
        contoursChevBarbe: "Contours Cheveux & Barbe",
        colorationCoupe: "Coloration & Coupe",
        colorationCoupeCiseaux: "Coloration & Coupe Ciseaux",
        decolorationCoupe: "Décoloration & Coupe"
      }
    },
    specialOffer: {
      title: "Offre Solidaire",
      description: "Tous les mardis, coupe à 10€ pour les personnes en situation de handicap",
      badge: "Chaque Mardi"
    },
    gallery: {
      title: "Notre Galerie",
      subtitle: "Nos Réalisations",
      description: "Découvrez notre savoir-faire à travers nos créations"
    },
    reviews: {
      title: "Avis Clients",
      subtitle: "Témoignages",
      description: "Ce que nos clients disent de nous",
      verified: "Client vérifié"
    },
    about: {
      title: "À Propos",
      subtitle: "Notre Histoire",
      description: "Alpha Barber, c'est plus qu'un salon de coiffure. C'est un lieu où tradition et modernité se rencontrent pour créer une expérience unique.",
      feature1Title: "Expertise",
      feature1Desc: "Des barbiers passionnés et hautement qualifiés",
      feature2Title: "Qualité",
      feature2Desc: "Produits professionnels haut de gamme",
      feature3Title: "Ambiance",
      feature3Desc: "Un cadre moderne et accueillant",
      feature4Title: "Satisfaction",
      feature4Desc: "Top Rated sur Treatwell 2025"
    },
    contact: {
      title: "Contact",
      subtitle: "Nous Trouver",
      address: "Adresse",
      phone: "Téléphone",
      hours: "Horaires",
      hoursValue: "Tous les jours 10h - 20h",
      appointment: "Avec ou sans rendez-vous",
      followUs: "Suivez-nous"
    },
    footer: {
      rights: "Tous droits réservés",
      madeWith: "Fait avec",
      in: "à Malakoff",
      logoSub: "Beauty & Care",
      description: "L'excellence au masculin. Un savoir-faire unique pour révéler votre style dans un cadre d'exception.",
      studio: "Studio",
      hoursLabel: "Lun - Dim",
      hoursTime: "10:00 - 20:00",
      legalNotice: "Mentions Légales",
      privacy: "Confidentialité"
    },
    video: {
      subtitle: "Notre Univers",
      title: "Découvrez",
      titleHighlight: "Notre Savoir-Faire",
      description: "Plongez dans l'atmosphère unique d'Alpha Barber Beauty. Une expérience de coiffure premium où chaque détail compte.",
      loading: "Chargement...",
      play: "Regarder",
      pause: "Pause",
      ariaLabel: "Vidéo de présentation Alpha Barber Beauty",
      feature1: "Visite Virtuelle",
      feature2: "Techniques Exclusives",
      feature3: "Ambiance Premium"
    }
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      prices: "Prices",
      gallery: "Gallery",
      about: "About",
      contact: "Contact",
      book: "Book Now"
    },
    hero: {
      subtitle: "PREMIUM BARBERSHOP",
      title: "The Art of",
      titleHighlight: "Men's Grooming",
      description: "Discover the excellence of modern barbering. Expertise, passion and style at the service of your image.",
      cta: "Book Appointment",
      ctaSecondary: "See our prices",
      badge: "Top Rated Treatwell 2025"
    },
    services: {
      title: "Our Services",
      subtitle: "Excellence & Craftsmanship",
      description: "Premium services to enhance your style",
      men: "MEN",
      children: "CHILDREN",
      childrenNote: "Under 12 years",
      eveningSurcharge: "+5€ from 6:30 PM",
      items: {
        coupe: "Haircut",
        coupeCiseaux: "Scissors Cut",
        coupeBouZero: "Buzz Cut",
        barbe: "Beard",
        bouZeroBarbe: "Buzz Cut & Beard",
        contours: "Line Up",
        contoursChevBarbe: "Hair & Beard Line Up",
        colorationCoupe: "Color & Cut",
        colorationCoupeCiseaux: "Color & Scissors Cut",
        decolorationCoupe: "Bleach & Cut"
      }
    },
    specialOffer: {
      title: "Solidarity Offer",
      description: "Every Tuesday, haircut at 10€ for people with disabilities",
      badge: "Every Tuesday"
    },
    gallery: {
      title: "Our Gallery",
      subtitle: "Our Work",
      description: "Discover our expertise through our creations"
    },
    reviews: {
      title: "Customer Reviews",
      subtitle: "Testimonials",
      description: "What our customers say about us",
      verified: "Verified customer"
    },
    about: {
      title: "About Us",
      subtitle: "Our Story",
      description: "Alpha Barber is more than a barbershop. It's a place where tradition and modernity meet to create a unique experience.",
      feature1Title: "Expertise",
      feature1Desc: "Passionate and highly skilled barbers",
      feature2Title: "Quality",
      feature2Desc: "Premium professional products",
      feature3Title: "Atmosphere",
      feature3Desc: "A modern and welcoming setting",
      feature4Title: "Satisfaction",
      feature4Desc: "Top Rated on Treatwell 2025"
    },
    contact: {
      title: "Contact",
      subtitle: "Find Us",
      address: "Address",
      phone: "Phone",
      hours: "Hours",
      hoursValue: "Every day 10AM - 8PM",
      appointment: "With or without appointment",
      followUs: "Follow us"
    },
    footer: {
      rights: "All rights reserved",
      madeWith: "Made with",
      in: "in Malakoff",
      logoSub: "Beauty & Care",
      description: "Excellence for men. A unique know-how to reveal your style in an exceptional setting.",
      studio: "Studio",
      hoursLabel: "Mon - Sun",
      hoursTime: "10:00 - 20:00",
      legalNotice: "Legal Notice",
      privacy: "Privacy"
    },
    video: {
      subtitle: "Our World",
      title: "Discover",
      titleHighlight: "Our Expertise",
      description: "Immerse yourself in the unique atmosphere of Alpha Barber Beauty. A premium grooming experience where every detail matters.",
      loading: "Loading...",
      play: "Watch",
      pause: "Pause",
      ariaLabel: "Alpha Barber Beauty presentation video",
      feature1: "Virtual Tour",
      feature2: "Exclusive Techniques",
      feature3: "Premium Atmosphere"
    }
  }
};

export const prices = {
  men: [
    { key: "coupe", price: "15€" },
    { key: "coupeCiseaux", price: "25€" },
    { key: "coupeBouZero", price: "15€" },
    { key: "barbe", price: "10€" },
    { key: "bouZeroBarbe", price: "20€" },
    { key: "contours", price: "5€" },
    { key: "contoursChevBarbe", price: "10€" },
    { key: "colorationCoupe", price: "35-65€" },
    { key: "colorationCoupeCiseaux", price: "45-75€" },
    { key: "decolorationCoupe", price: "50-75€" }
  ],
  children: [
    { key: "coupe", price: "10€" },
    { key: "coupeCiseaux", price: "10€" },
    { key: "coupeBouZero", price: "10€" },
    { key: "contours", price: "5€" }
  ]
};

export const contactInfo = {
  address: "28 Bd de Stalingrad, 92240 Malakoff",
  phone: "01 75 32 35 77",
  instagram: "",
  instagramUrl: "https://www.instagram.com/alphabarber_beauty/",
  facebookUrl: "https://www.facebook.com/share/1BVHcqCfwT/?mibextid=wwXIfr",
  tiktokUrl: "https://www.tiktok.com/@alphabarberbeauty?is_from_webapp=1&sender_device=pc"
};